import { ReactNode } from "react";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  description?: string;
  centered?: boolean;
  light?: boolean;
}

export default function SectionHeader({ title, subtitle, description, centered = true, light = false }: SectionHeaderProps) {
  return (
    <div className={`mb-10 md:mb-14 ${centered ? "text-center" : ""}`}>
      {subtitle && (
        <p className={`text-sm font-semibold uppercase tracking-wider mb-3 ${light ? "text-accent-300" : "text-accent-600"}`}>
          {subtitle}
        </p>
      )}
      <h2 className={`text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight ${light ? "text-white" : "text-foreground-950"}`}>
        {title}
      </h2>
      {description && (
        <p className={`mt-4 text-base md:text-lg max-w-3xl leading-relaxed ${centered ? "mx-auto" : ""} ${light ? "text-foreground-300" : "text-foreground-600"}`}>
          {description}
        </p>
      )}
    </div>
  );
}